const emailRegExp = /\S+@\S+\.\S+/;

export const validateEmail = (email: string): boolean => emailRegExp.test(email);

export const LINK_LEARN_MORE = "https://support.similarweb.com/hc/en-us/articles/360010602497-Build-a-Dashboard";
